import { UserApi } from 'mvppoker-portal-common/api'
import React, { useState } from 'react'
import ReactCodeInput from 'react-code-input'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { store } from '../../../state/AppStore'
import { setActiveUser } from '../../../state/reducers/activeUser'
import { clearRegisteringUser } from '../../../state/reducers/registeringUser'
import { setGameConfig } from '../../../state/reducers/AppConfig'
import { handleError, useApi } from '../../../utils/useApi'
import { MVPButton } from '../../../Views/Buttons/MVPButton'
import { FullPageHeader } from '../../../Views/FullPageHeader/FullPageHeader'
import { useNavigate } from '../../navigation'
import { makeActiveGame } from '../../../state/reducers/activeGame'
import './RegistrationConfirmationEmailPage.scss'

const CodeInput = ({ onChange }: { onChange: (value: string) => void }) => {
	return (
		<ReactCodeInput
			type='text'
			fields={6}
			name='code'
			inputMode='numeric'
			placeholder='-'
			onChange={onChange}
			inputStyle={{
				fontFamily: 'monospace',
				borderRadius: '6px',
				border: '1px solid white',
				margin: '4px',
				paddingLeft: '0.5rem',
				width: '36px',
				height: '42px',
				fontSize: '2rem',
				color: 'white',
				backgroundColor: 'transparent',
				boxShadow: '0 0 .1rem #fff, 0 0 .3rem #fff,inset 0 0 .1rem #fff',
			}}
		/>
	)
}

export default () => {
	const [code, setCode] = useState('')
	const [isLoading, setLoading] = useState(false)
	const userApi = useApi(UserApi)
	const dispatch = useDispatch()
	const goToLogin = useNavigate('login')

	const handleConfirm = () => {
		const { credentials } = store.getState().registeringUser

		if (!credentials) {
			return /* TODO HANDLE ERROR */
		}

		setLoading(true)

		const confirmEmailAsync = async () => {
			const loginResponse = (
				await userApi.authUserConfirmEmail({
					username: credentials.email,
					password: credentials.password,
					code,
				})
			).data
			
			dispatch(clearRegisteringUser())
			dispatch(setGameConfig(loginResponse.config))
			dispatch(setActiveUser(loginResponse))
			const activeRoom = loginResponse.currentGames[0]
			const userId = loginResponse.user.id
			if (activeRoom && userId){
				dispatch(makeActiveGame({ ...activeRoom, userId }))
			}
			goToLogin()
			toast.success('Registration Succesfull!')
		}

		confirmEmailAsync().catch((err) => {
			setLoading(false)
			handleError(err)
		})
	}

	const handleResendCode = () => {
		const { user } = store.getState().registeringUser

		if (!user) {
			return /* TODO handle error */
		}

		userApi.authUserResendEmailConfirmationCode(user.id).catch(handleError)
	}

	return (
		<div id='registration-confirmation-email-page' className='stretch-page'>
			<div className='middle-col'>
				<FullPageHeader title='Confirm your email' />
				<span id='otc-label'>We&apos;ve sent a one time access code to your email that will be valid for the next 15 minutes</span>
				<CodeInput onChange={setCode} />
				<MVPButton id='email-code-confirm-button' onClick={handleConfirm} loading={isLoading}>
					Confirm
				</MVPButton>
				<MVPButton id='otc-resend-button' className='clear' onClick={handleResendCode}>
					Resend Code
				</MVPButton>
			</div>
		</div>
	)
}
